<template>
  <sc-modal-card class="sc-modal-tags__border">
    <template slot="title">
      <h2 class="modal-card-title">
        Nova tag Xml
      </h2>
    </template>
    <template slot="body">
      <sc-form
        :hasStyle="false"
        ref="form"
        :form="tag"
        :rules="rules"
        @submit="saveTag">
        <template slot="fields" slot-scope="{ fields }">

          <div class="column">
            <sc-field
              label="Nome Intelipost"
              prop="tms_name">
              <sc-select v-model="fields.tms_name" expanded>
                <option selected :value="null">Selecione</option>
                <option
                  v-for="value in enumTmsName"
                  :key="value.name"
                  :value="value.name">
                    {{ value.name }}
                </option>
              </sc-select>
            </sc-field>
          </div>

          <div class="column" expanded>
            <sc-field label="Nome Transportadora" prop="logistic_provider_name">
              <sc-input
              v-model="fields.logistic_provider_name"
              placeholder="Nome da taxa usado pela transportadora" />
            </sc-field>
          </div>

          <div class="column">
            <sc-field label="Tag de nomenclatura" prop="tag_name">
              <sc-input
              v-model="fields.tag_name"
              placeholder="Digite a tag xml de nomenclatura" />
            </sc-field>
          </div>
          <div class="column">
            <sc-field label="Tag de valor" prop="tag_value">
              <sc-input
              v-model="fields.tag_value"
              placeholder="Digite tag xml de valor" />
            </sc-field>
          </div>
        </template>

        <template
        slot="actions"
        slot-scope="{ isValid }"
        class="sc-modal-tags__footer">
          <sc-field>
            <sc-button
              text="Cancelar"
              @click="closeModal" />
            <sc-button
              type="submit"
              theme="primary"
              text="Salvar"
              :loading="loading"
              :disabled="!isValid"
              @click="closeModal" />
          </sc-field>
        </template>
      </sc-form>
    </template>
  </sc-modal-card>
</template>

<script>
import {
  ScModalCard,
  ScButton,
  ScField,
  ScForm,
  ScInput,
  ScSelect,
  ScToast,
} from '@intelipost-js/secure-components';
import { createNamespacedHelpers } from 'vuex';
import EnumTmsName from '../../enums/EnumTmsName';

const {
  mapState,
  mapActions,
  mapMutations,
} = createNamespacedHelpers('recon/xmlCteTags');

export default {
  name: 'sc-modal-tag',
  data() {
    return {
      rules: {
        tms_name: [
          {
            required: true,
            message: 'Selecione o campo <strong>Nome Intelipost</strong>',
          },
        ],
        logistic_provider_name: [
          {
            type: 'string',
            required: true,
            message: 'Preencha o campo <strong>Nome Transportadora</strong>',
            trigger: 'input',
          },
        ],
        tag_name: [
          {
            type: 'string',
            required: true,
            message: 'Preencha com a tag Xml de nomenclatura',
            trigger: 'input',
          },
        ],
        tag_value: [
          {
            type: 'string',
            required: true,
            message: 'Preencha com a tag Xml de valor',
            trigger: 'input',
          },
        ],

      },
    };
  },
  computed: {
    ...mapState([
      'loading',
      'tag',
    ]),
    enumTmsName() {
      return EnumTmsName;
    },
  },
  methods: {
    ...mapMutations([
      'setTag',
    ]),
    ...mapActions([
      'createNewTag',
    ]),
    closeModal() {
      this.$parent.close();
    },
    getTaxesType(formFields) {
      const selectedValue = (formFields || {}).tms_name;
      const value = Object.values(EnumTmsName).find(item => item.name === selectedValue);

      return value ? value.taxes_type : '';
    },
    saveTag(form) {
      return this.createNewTag({
        tms_name: form.tms_name,
        logistic_provider_name: form.logistic_provider_name,
        taxes_type: this.getTaxesType(form),
        tag_name: form.tag_name,
        tag_value: form.tag_value,
      })
        .then(() => ScToast.success('Nova tag gerada com sucesso!'));
    },
  },
  components: {
    ScButton,
    ScField,
    ScForm,
    ScInput,
    ScSelect,
    ScToast,
    ScModalCard,
  },
};
</script>

<style lang="scss" scoped>
  .sc-modal-tags {
    &__border{
      border-radius: 8px;
    }
    &__form {
      &__text {
        font-weight: bold;
      }
      &.sc-form {
        box-shadow: none;
        margin-bottom: 0;
        .sc-form__fields {
          padding: 0;
        }
      }
      &__field-btn {
        display: flex;
        justify-content: flex-end;
        width: 100%;
      }
    }
  }
</style>	</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/components/sc-modal-tag/ScModalTag.vue?596d53e8